import React from 'react';
import PropTypes from 'prop-types';
import { paleteItems } from './paleteItems';

import './IconColorPalete.css';

const IconColorPalete = ({
  setIconColor,
  iconColor,
}) => {
  return (
    <div className="icon-color-palete__component">
      <div className="icon-color-palete-wrapper">
        {paleteItems.map(i => (
          <div
            key={`icon_color_palete_item_id_${i.name}`}
            className={`icon-color-palete-item ${iconColor === i.color ? 'active' : ''} ${i.color === 'transparent' ? 'transparent' : ''}`}
            style={{ backgroundColor: i.color }}
            onClick={() => {
              setIconColor(i.color);
            }}
          />
        ))}
      </div>
    </div>
  );
};

IconColorPalete.propTypes = {
  setIconColor: PropTypes.func,
  iconColor: PropTypes.string,
  customThemeColor: PropTypes.string,
};
IconColorPalete.defaultProps = {
  setIconColor: null,
  iconColor: '',
  customThemeColor: '',
};

export default IconColorPalete;
